import { render } from "./EndPage.vue?vue&type=template&id=7681968c&scoped=true"
import script from "./EndPage.vue?vue&type=script&lang=js"
export * from "./EndPage.vue?vue&type=script&lang=js"

import "./EndPage.vue?vue&type=style&index=0&id=7681968c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7681968c"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QFooter,QToolbar,QToolbarTitle,QSeparator,QImg,QList,QItem,QItemSection});qInstall(script, 'directives', {Ripple});
